import { Payment } from '../../../models/AppointmentBookScheduleRequest';
import { fetchPaymentsBySpecialistAndOffice } from '../../../modules/appointmentBook';

type usePaymentProps = {
  handleGenericErrors: () => void;
};

export const usePayment = ({ handleGenericErrors }: usePaymentProps) => {
  const getPayments = async (props: { officeId: string; specialistId: string; subgroup: string }) => {
    try {
      const result = await fetchPaymentsBySpecialistAndOffice({
        channel: 'care-plus',
        ...props
      });

      if (result.data?.length > 0) return result.data;
      else throw new Error();
    } catch (error: any) {
      handleGenericErrors();
    }
  };

  const getPayment = async (props: {
    officeId: string;
    specialistId: string;
    subgroup: string;
  }): Promise<Payment | undefined> => {
    const paymentResult = await getPayments(props);

    if (paymentResult?.length) {
      const [payment] = paymentResult;
      return {
        healthInsuranceId: payment.id,
        description: payment.description,
        isHealthInsurance: payment.isHealthInsurance,
        healthPlanId: payment.planId,
        planName: payment.description
      };
    }
  };

  return { getPayment };
};
